export default __webpack_public_path__ + "static/collectionImageMobile-124253fc29b89afd76de92c1fb62bf6d.png";